import React from "react";
import { useTranslation } from "react-i18next";
import Seo from "../components/Seo";
import Dimension from "../components/Dimension";
import PageHead from "../components/PageHead";
import { LT_BRAND } from "../data";

function Contact() {
  const { t } = useTranslation();

  const channels = [
    {
      k: t("contact.emailLabel"),
      v: t("contact.emailValue"),
      sub: t("contact.emailSub"),
      href: `mailto:${LT_BRAND.contactEmail}`,
      primary: true,
    },
    {
      k: t("contact.githubLabel"),
      v: t("contact.githubValue"),
      sub: t("contact.githubSub"),
      href: LT_BRAND.github,
    },
    {
      k: t("contact.linkedinLabel"),
      v: t("contact.linkedinValue"),
      sub: t("contact.linkedinSub"),
      href: LT_BRAND.linkedin,
    },
  ];

  return (
    <div className="container">
      <Seo page="contact" path="/contact" />

      <PageHead title={t("contact.heroTitle")} lede={t("contact.heroDesc")} />

      <div className="band">
        <Dimension label={t("dimension.channels", { n: channels.length })} />
      </div>

      <div className="channels">
        {channels.map((c) => (
          <div key={c.k} className="channel">
            <div className="k">{c.k}</div>
            <a
              className={`v${c.primary ? " v-primary" : ""}`}
              href={c.href}
              target={c.href.startsWith("mailto:") ? undefined : "_blank"}
              rel="noopener noreferrer"
            >
              {c.v}
            </a>
            <p className="sub">{c.sub}</p>
          </div>
        ))}
      </div>

      <div className="band" />

      <section className="col2 band-bottom">
        <div>
          <h2 className="h-section">{LT_BRAND.address}</h2>
          <dl className="deflist deflist-studio">
            <dt>{t("contact.uidLabel")}</dt>
            <dd>{LT_BRAND.uid}</dd>
            <dt>{t("contact.timezoneLabel")}</dt>
            <dd>{t("contact.timezoneValue")}</dd>
            <dt>{t("contact.coordinatesLabel")}</dt>
            <dd>
              <a
                className="link"
                href={LT_BRAND.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {LT_BRAND.coords}
              </a>
            </dd>
          </dl>
          <p className="btn-row map-link">
            <a
              className="btn"
              href={LT_BRAND.mapsUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("contact.mapsLink")}
            </a>
          </p>
        </div>

        <div>
          <div className="map-frame">
            <svg viewBox="0 0 600 380" role="img" aria-label={LT_BRAND.coords}>
              <defs>
                <pattern
                  id="plangrid"
                  width="30"
                  height="30"
                  patternUnits="userSpaceOnUse"
                >
                  <path
                    d="M 30 0 L 0 0 0 30"
                    fill="none"
                    stroke="var(--ruled)"
                    strokeWidth="1"
                  />
                </pattern>
              </defs>
              <rect width="600" height="380" fill="var(--paper)" />
              <rect width="600" height="380" fill="url(#plangrid)" />

              {/* blocks */}
              {Array.from({ length: 34 }).map((_, i) => (
                <rect
                  key={i}
                  x={((i * 71) % 560) + 12}
                  y={((i * 53) % 330) + 14}
                  width={26 + (i % 5) * 9}
                  height={20 + (i % 4) * 8}
                  fill="var(--wash)"
                  stroke="var(--ruled)"
                  strokeWidth="1"
                />
              ))}

              {/* roads */}
              <path
                d="M0 232 L600 208"
                stroke="var(--plan)"
                strokeWidth="1.4"
                fill="none"
              />
              <path
                d="M214 0 L268 380"
                stroke="var(--plan)"
                strokeWidth="1.4"
                fill="none"
              />
              <path
                d="M392 0 L360 380"
                stroke="var(--plan)"
                strokeWidth="1.4"
                fill="none"
              />
              <path
                d="M-10 150 Q 160 128 320 172 T 620 158"
                stroke="var(--plan)"
                strokeWidth="1"
                fill="none"
                opacity="0.6"
              />

              {/* setting-out marks on the studio */}
              <g transform="translate(280,205)">
                <path
                  d="M-46 0 H46 M0 -46 V46"
                  stroke="var(--plan)"
                  strokeWidth="1"
                />
                <circle
                  r="13"
                  fill="none"
                  stroke="var(--plan)"
                  strokeWidth="1.4"
                />
                <circle r="3.5" fill="var(--plan)" />
                {/* leader line out to a knocked-out label, so no rule runs
                    through the text */}
                <path
                  d="M9 -9 L44 -44 H70"
                  stroke="var(--plan)"
                  strokeWidth="1"
                  fill="none"
                />
                <rect
                  x="44"
                  y="-84"
                  width="150"
                  height="38"
                  fill="var(--paper)"
                  stroke="var(--ruled)"
                  strokeWidth="1"
                />
                <text
                  x="54"
                  y="-66"
                  fill="var(--ink)"
                  fontFamily="var(--font)"
                  fontSize="14"
                  fontWeight="600"
                >
                  LT+ studio
                </text>
                <text
                  x="54"
                  y="-52"
                  fill="var(--graphite)"
                  fontFamily="var(--font)"
                  fontSize="12"
                >
                  {LT_BRAND.street}
                </text>
              </g>
            </svg>
          </div>
          <Dimension label={LT_BRAND.coords} />
        </div>
      </section>
    </div>
  );
}

export default Contact;
